<template>
  <!-- 错误页面 -->
  <!-- 当没有权限查看页面 会跳转到当前页面 -->
  <div class="base_container">
    <span>当前用户信息有误或权限过低，请联系管理员</span>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.base_container
  width 100%
  height: 100%
  background: rgba(#233a62,0.5)
  box-sizing border-box
  pointer-events: auto
  span
    line-height: 50px
    font-weight: 600
    color #fff
</style>
